import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  userInteraction: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('userInteraction');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.userInteraction.length > 0 ? action.userInteraction : [];  
  return updateObject(state, {
    userInteraction: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, userInteraction:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_INTERACTION_START:
      return fetchStart(state);
    case actionTypes.FETCH_USER_INTERACTION_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_USER_INTERACTION_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
